<div class="btn-float">
    <ng-content></ng-content>
</div>
